export const TYPE_SIGNATURE_FONTS = [
  {
    id: 'allura',
    label: 'Allura',
    family: '"Allura", "Lucida Handwriting", cursive',
    googleFont: 'Allura'
  },
  {
    id: 'alex-brush',
    label: 'Alex Brush',
    family: '"Alex Brush", "Brush Script MT", cursive',
    googleFont: 'Alex Brush'
  },
  {
    id: 'bilbo-swash-caps',
    label: 'Bilbo Swash Caps',
    family: '"Bilbo Swash Caps", "Brush Script MT", cursive',
    googleFont: 'Bilbo Swash Caps'
  },
  {
    id: 'cedarville-cursive',
    label: 'Cedarville Cursive',
    family: '"Cedarville Cursive", "Segoe Script", cursive',
    googleFont: 'Cedarville Cursive'
  },
  {
    id: 'great-vibes',
    label: 'Great Vibes',
    family: '"Great Vibes", "Lucida Handwriting", cursive',
    googleFont: 'Great Vibes'
  },
  {
    id: 'sign-painter',
    label: 'SignPainter',
    family: '"Homemade Apple", "SignPainter", "Segoe Script", cursive',
    googleFont: 'Homemade Apple'
  }
];

export const SIGNATURE_TABS = [
  { value: 'draw', label: 'Draw signature' },
  { value: 'type', label: 'Type signature' }
];

export const SIGNATURE_HINT =
  'By signing, I acknowledge that this electronic signature is legally binding and equivalent to my handwritten signature.';
